import { BASE_API_URL } from "utils/constants";
import { get } from '../../utils/api';
import { DataResponse } from "../response";

export interface TaskModel {
    taskId: string;
    summary: string;
    workFlowName: string;
    workFlowCode: string;
    createTime: string;
}

export type ValueTaskModel = {
    listTasks: TaskModel[];
    total: number;
};

export type ValueNewsModel = {
    newsId: string;
    title: string;
    createTime: string;
};

// Kiểu dữ liệu api trả về của Home
export type ValueModel = {
    data: number;
}

// Interface của Home service
export interface IHomeServices {
    // Lấy data bảng thông tin - tổng khách hàng
    getListCountCustomer(): Promise<DataResponse<ValueModel[]>>;
    // Lấy data bảng thông tin - tổng liên hệ
    getListCountContact(): Promise<DataResponse<ValueModel[]>>;
    // Lấy data bảng thông tin - tổng công việc
    getListCountTask(): Promise<DataResponse<ValueModel[]>>;
    // Lấy data bảng thông tin - công việc được phân công
    getListCountTaskToDo(employeeCode: string): Promise<DataResponse<ValueModel[]>>;
    // Lấy data bảng thông tin - công việc đang thực hiện
    getListCountTaskProcessing(employeeCode: string): Promise<DataResponse<ValueModel[]>>;
    // Lấy data bảng thông tin - công việc đã quá hạn
    getListCountTaskExpired(employeeCode: string): Promise<DataResponse<ValueModel[]>>;
    // Lấy data bảng thông tin - công việc đã hoàn thành
    getListCountTaskCompleted(employeeCode: string): Promise<DataResponse<ValueModel[]>>;
    // Lấy data cập nhật hoạt động - số lượng ghé thăm
    getListCountVisiting(selectedCommonDate: string): Promise<DataResponse<ValueModel[]>>;
    // Lấy data cập nhật hoạt động - thăm hỏi khách hàng
    getListCountVisitingCustomer(selectedCommonDate: string): Promise<DataResponse<ValueModel[]>>;
    // Lấy data cập nhật hoạt động - nhiệm vụ khác
    getListCountActivities(selectedCommonDate: string): Promise<DataResponse<ValueModel[]>>;
    // Lấy data bảng tin
    getListNewsView(accountId: string): Promise<DataResponse<ValueNewsModel[]>>;
    // Lấy data thông tin cập nhật
    getListUpdateInformation(): Promise<DataResponse<ValueTaskModel>>;
}

// Hàm khởi tạo các phương thức của Home service
export function createHomeServices(): IHomeServices {
    return {
        // Hàm lấy data bảng thông tin - tổng khách hàng
        getListCountCustomer: async () => {
            return (
                await get(
                    BASE_API_URL,
                    `Home/count-customer`,
                )
            ).data
        },
        // Hàm lấy data bảng thông tin - tổng liên hệ
        getListCountContact: async () => {
            return (
                await get(
                    BASE_API_URL,
                    `Home/count-contact`,
                )
            ).data
        },
        // Hàm lấy data bảng thông tin - tổng công việc
        getListCountTask: async () => {
            return (
                await get(
                    BASE_API_URL,
                    `Home/count-task`,
                )
            ).data
        },
        // Hàm lấy data bảng thông tin - công việc được phân công
        getListCountTaskToDo: async (employeeCode) => {
            return (
                await get(
                    BASE_API_URL,
                    `Home/count-task-todo?${employeeCode ? `employeeCode=${employeeCode}` : ``}`,
                )
            ).data
        },
        // Hàm lấy data bảng thông tin - công việc đang thực hiện
        getListCountTaskProcessing: async (employeeCode) => {
            return (
                await get(
                    BASE_API_URL,
                    `Home/count-task-processing?${employeeCode ? `employeeCode=${employeeCode}` : ``}`,
                )
            ).data
        },
        // Hàm lấy data bảng thông tin - công việc đã quá hạn
        getListCountTaskExpired: async (employeeCode) => {
            return (
                await get(
                    BASE_API_URL,
                    `Home/count-task-expired?${employeeCode ? `employeeCode=${employeeCode}` : ``}`,
                )
            ).data
        },
        // Hàm lấy data bảng thông tin - công việc đã hoàn thành
        getListCountTaskCompleted: async (employeeCode) => {
            return (
                await get(
                    BASE_API_URL,
                    `Home/count-task-completed?${employeeCode ? `employeeCode=${employeeCode}` : ``}`,
                )
            ).data
        },
        // Hàm lấy data cập nhật hoạt động - số lượng ghé thăm
        getListCountVisiting: async (selectedCommonDate) => {
            return (
                await get(
                    BASE_API_URL,
                    `Home/count-visiting?${selectedCommonDate ? `selectedCommonDate=${selectedCommonDate}` : ``}`,
                )
            ).data
        },
        // Hàm lấy data cập nhật hoạt động - thăm hỏi khách hàng
        getListCountVisitingCustomer: async (selectedCommonDate) => {
            return (
                await get(
                    BASE_API_URL,
                    `Home/count-visiting-customer?${selectedCommonDate ? `selectedCommonDate=${selectedCommonDate}` : ``}`,
                )
            ).data
        },
        // Hàm lấy data cập nhật hoạt động - nhiệm vụ khác
        getListCountActivities: async (selectedCommonDate) => {
            return (
                await get(
                    BASE_API_URL,
                    `Home/count-activities?${selectedCommonDate ? `selectedCommonDate=${selectedCommonDate}` : ``}`,
                )
            ).data
        },
        // Hàm lấy data bảng tin
        getListNewsView: async (accountId) => {
            return (
                await get(
                    BASE_API_URL,
                    `Home/news-view?${accountId ? `accountId=${accountId}` : ``}`,
                )
            ).data
        },
        // Hàm lấy data thông tin cập nhật
        getListUpdateInformation: async () => {
            return (
                await get(
                    BASE_API_URL,
                    `Home/update-information`,
                )
            ).data
        },
    }
}
